export enum UserActionTypeArchiveOptionsChanged {
  AddedArchiveOptions = 'AddedArchiveOptions',
  DeletedArchiveOptions = 'DeletedArchiveOptions',
  EditedArchiveOptions = 'EditedArchiveOptions'
}
